<template>
  <div class="flex flex-col gap-3">
    <div class="text-muted-foreground text-sm font-medium leading-5">
      <slot name="title">{{ title }}</slot>
    </div>
    <div class="flex flex-col gap-3"><slot /></div>
  </div>
</template>

<script>
export default { name: "SectionBlock", props: { title: String } };
</script>
